import Box from '@redbubble/design-system/src/Box';
import React, { useEffect, useRef } from 'react';
export var useDrag = function () {
    var dragContainerRef = useRef(null);
    var dragStart = useRef({ pointerId: -1, x: 0, scrollLeft: 0 });
    var didDrag = useRef(false);
    var dragContainer = dragContainerRef.current;
    useEffect(function () {
        if (!dragContainer)
            return;
        var handlePointerDown = function (event) {
            if (event.button !== 0)
                return;
            dragStart.current = {
                pointerId: event.pointerId,
                x: event.clientX,
                scrollLeft: dragContainer.scrollLeft,
            };
            didDrag.current = false;
        };
        var handlePointerMove = function (event) {
            if (dragStart.current.pointerId !== event.pointerId)
                return;
            var distance = event.clientX - dragStart.current.x;
            if (!didDrag.current && Math.abs(distance) <= 5)
                return;
            if (!didDrag.current) {
                didDrag.current = true;
                dragContainer.setPointerCapture(event.pointerId);
            }
            dragContainer.scrollLeft = dragStart.current.scrollLeft - distance;
        };
        var stopDragging = function (event) {
            if (dragStart.current.pointerId !== event.pointerId)
                return;
            dragStart.current.pointerId = -1;
            if (dragContainer.hasPointerCapture(event.pointerId)) {
                dragContainer.releasePointerCapture(event.pointerId);
            }
        };
        var handleDragStart = function (event) {
            event.preventDefault();
        };
        var handleClickCapture = function (event) {
            if (didDrag.current) {
                event.preventDefault();
                event.stopPropagation();
                didDrag.current = false;
            }
        };
        dragContainer.addEventListener('pointerdown', handlePointerDown);
        dragContainer.addEventListener('pointermove', handlePointerMove);
        dragContainer.addEventListener('pointerup', stopDragging);
        dragContainer.addEventListener('pointercancel', stopDragging);
        dragContainer.addEventListener('dragstart', handleDragStart);
        dragContainer.addEventListener('click', handleClickCapture, true);
        return function () {
            dragContainer.removeEventListener('pointerdown', handlePointerDown);
            dragContainer.removeEventListener('pointermove', handlePointerMove);
            dragContainer.removeEventListener('pointerup', stopDragging);
            dragContainer.removeEventListener('pointercancel', stopDragging);
            dragContainer.removeEventListener('dragstart', handleDragStart);
            dragContainer.removeEventListener('click', handleClickCapture, true);
        };
    }, [dragContainer]);
    return dragContainerRef;
};
export var TopicNavContainer = function (_a) {
    var children = _a.children;
    var dragRef = useDrag();
    return (React.createElement(Box, { ref: dragRef, element: "nav", display: "flex", alignItems: "stretch", paddingY: "xs", className: "rb-topic-nav", "aria-label": "Topic navigation" }, children));
};
